module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-drawer', {
    attrs: {
      "custom-class": "ads_create",
      "title": "创建广告",
      "size": "60%",
      "modal": _vm.modal,
      "visible": _vm.AdModalDrawer,
      "direction": "rtl"
    },
    on: {
      "update:visible": function($event) {
        _vm.AdModalDrawer = $event
      }
    }
  }, [_c('el-row', {
    staticStyle: {
      "position": "relative",
      "height": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "20px",
      "top": "0",
      "right": "0",
      "bottom": "0",
      "overflow-y": "auto",
      "padding-right": "2%",
      "overflow-x": "hidden"
    }
  }, [_c('el-container', [_c('el-aside', {
    attrs: {
      "width": "40%"
    }
  }, [_c('h3', [_vm._v("广告组列表")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": "输入关键字进行过滤",
      "clearable": "",
      "size": "small"
    },
    model: {
      value: (_vm.filterText),
      callback: function($$v) {
        _vm.filterText = $$v
      },
      expression: "filterText"
    }
  }), _vm._v(" "), _c('el-tree', {
    ref: "tree",
    attrs: {
      "props": _vm.defaultProps,
      "data": _vm.CampaignListData,
      "filter-node-method": _vm.filterNode,
      "accordion": ""
    },
    on: {
      "node-click": _vm.getCurrentNode
    }
  })], 1), _vm._v(" "), _c('el-container', [_c('el-main', [_c('h3', [_c('i', {
    staticClass: "fa fa-circle",
    staticStyle: {
      "color": "#ff6f5e",
      "font-size": "10px"
    }
  }), _vm._v(" " + _vm._s(_vm.campaign_name))]), _vm._v(" "), _c('el-tabs', {
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "广告基础属性",
      "name": "second"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "10px",
      "padding": "15px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.AdsForm,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "下载方式"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.AdsForm.download_type),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm, "download_type", $$v)
      },
      expression: "AdsForm.download_type"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "DOWNLOAD_URL"
    }
  }, [_vm._v("下载链接")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "EXTERNAL_URL"
    }
  }, [_vm._v("落地页")])], 1)], 1), _vm._v(" "), (_vm.AdsForm.download_type == 'EXTERNAL_URL') ? _c('el-form-item', {
    attrs: {
      "label": "来源"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.CreateForm.source),
      callback: function($$v) {
        _vm.$set(_vm.CreateForm, "source", $$v)
      },
      expression: "CreateForm.source"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.AdsForm.download_type == 'EXTERNAL_URL') ? _c('el-form-item', {
    attrs: {
      "label": "链接地址"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.AdsForm.external_url),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm, "external_url", $$v)
      },
      expression: "AdsForm.external_url"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.AdsForm.download_type == 'DOWNLOAD_URL') ? _c('el-form-item', {
    attrs: {
      "label": "下载地址"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.AdsForm.download_url),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm, "download_url", $$v)
      },
      expression: "AdsForm.download_url"
    }
  }, [_c('a', {
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "slot": "append",
      "href": _vm.AdsForm.download_url,
      "target": "__blank"
    },
    slot: "append"
  }, [_vm._v("访问")])])], 1) : _vm._e(), _vm._v(" "), (_vm.AdsForm.download_type == 'DOWNLOAD_URL') ? _c('el-form-item', {
    attrs: {
      "label": "应用包名"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.AdsForm.package),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm, "package", $$v)
      },
      expression: "AdsForm.package"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.AdsForm.download_type == 'DOWNLOAD_URL') ? _c('el-form-item', {
    attrs: {
      "label": "应用名"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.CreateForm.app_name),
      callback: function($$v) {
        _vm.$set(_vm.CreateForm, "app_name", $$v)
      },
      expression: "CreateForm.app_name"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "转化ID"
    }
  }, [_c('el-autocomplete', {
    attrs: {
      "popper-class": "my-autocomplete",
      "size": "small",
      "fetch-suggestions": _vm.querySearch,
      "placeholder": "请输入转化ID"
    },
    on: {
      "select": _vm.handleSelect
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "name"
        }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('span', {
          staticClass: "addr"
        }, [_vm._v(_vm._s(item.name))])]
      }
    }]),
    model: {
      value: (_vm.AdsForm.convert_id),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm, "convert_id", $$v)
      },
      expression: "AdsForm.convert_id"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "定向人群"
    }
  }, [_c('el-select', {
    staticClass: "custom_audience",
    attrs: {
      "size": "small",
      "multiple": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.AdsForm.retargeting_tags_include),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm, "retargeting_tags_include", $$v)
      },
      expression: "AdsForm.retargeting_tags_include"
    }
  }, _vm._l((_vm.custom_audience), function(item) {
    return _c('el-option', {
      key: item.custom_audience_id,
      attrs: {
        "label": item.name,
        "value": item.custom_audience_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "排除人群"
    }
  }, [_c('el-select', {
    staticClass: "custom_audience",
    attrs: {
      "size": "small",
      "multiple": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.AdsForm.retargeting_tags_exclude),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm, "retargeting_tags_exclude", $$v)
      },
      expression: "AdsForm.retargeting_tags_exclude"
    }
  }, _vm._l((_vm.custom_audience), function(item) {
    return _c('el-option', {
      key: item.custom_audience_id,
      attrs: {
        "label": item.name,
        "value": item.custom_audience_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "兴趣定向"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.AdsForm.ad_tag),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm, "ad_tag", $$v)
      },
      expression: "AdsForm.ad_tag"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": ""
    }
  }, [_vm._v("不限")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v("系统推荐")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "网络"
    }
  }, [_c('el-checkbox-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.AdsForm.ac),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm, "ac", $$v)
      },
      expression: "AdsForm.ac"
    }
  }, [_c('el-checkbox-button', {
    attrs: {
      "label": "WIFI"
    }
  }, [_vm._v("WIFI")]), _vm._v(" "), _c('el-checkbox-button', {
    attrs: {
      "label": "2G"
    }
  }, [_vm._v("2G")]), _vm._v(" "), _c('el-checkbox-button', {
    attrs: {
      "label": "3G"
    }
  }, [_vm._v("3G")]), _vm._v(" "), _c('el-checkbox-button', {
    attrs: {
      "label": "4G"
    }
  }, [_vm._v("4G")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "最低系统版本",
      "label-width": "120px"
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.AdsForm.version),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm, "version", $$v)
      },
      expression: "AdsForm.version"
    }
  }, _vm._l((_vm.versionList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "出价方式"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.AdsForm.smart_bid_type),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm, "smart_bid_type", $$v)
      },
      expression: "AdsForm.smart_bid_type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "SMART_BID_CUSTOM"
    }
  }, [_vm._v("手动")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "SMART_BID_CONSERVATIVE"
    }
  }, [_vm._v("自动")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.AdsForm.smart_bid_type == 'SMART_BID_CUSTOM'),
      expression: "AdsForm.smart_bid_type=='SMART_BID_CUSTOM'"
    }],
    attrs: {
      "label": "目标出价"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.AdsForm.cpa_bid),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm, "cpa_bid", $$v)
      },
      expression: "AdsForm.cpa_bid"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("元")])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "投放方式"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.AdsForm.flow_control_mode),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm, "flow_control_mode", $$v)
      },
      expression: "AdsForm.flow_control_mode"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "FLOW_CONTROL_MODE_FAST"
    }
  }, [_vm._v("优先跑量")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "FLOW_CONTROL_MODE_BALANCE"
    }
  }, [_vm._v("均衡投放")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "FLOW_CONTROL_MODE_SMOOTH"
    }
  }, [_vm._v("优先低成本")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "预算"
    }
  }, [_c('el-input', {
    staticClass: "input-with-select",
    attrs: {
      "size": "small",
      "placeholder": "设置预算金额"
    },
    model: {
      value: (_vm.AdsForm.budget),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm, "budget", $$v)
      },
      expression: "AdsForm.budget"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "slot": "prepend",
      "placeholder": "请选择"
    },
    slot: "prepend",
    model: {
      value: (_vm.AdsForm.budget_mode),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm, "budget_mode", $$v)
      },
      expression: "AdsForm.budget_mode"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "日预算",
      "value": "BUDGET_MODE_DAY"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "总预算",
      "value": "BUDGET_MODE_TOTAL"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "投放时间"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.AdsForm.schedule_type),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm, "schedule_type", $$v)
      },
      expression: "AdsForm.schedule_type"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "SCHEDULE_FROM_NOW"
    }
  }, [_vm._v("从今天起长期投放")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "SCHEDULE_START_END"
    }
  }, [_vm._v("设置开始和结束时间")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.AdsForm.schedule_type == 'SCHEDULE_START_END'),
      expression: "AdsForm.schedule_type=='SCHEDULE_START_END'"
    }]
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "44%"
    },
    attrs: {
      "value-format": "yyyy-MM-dd HH:mm",
      "size": "small",
      "type": "date",
      "placeholder": "开始日期"
    },
    model: {
      value: (_vm.AdsForm.start_time),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm, "start_time", $$v)
      },
      expression: "AdsForm.start_time"
    }
  }), _vm._v("-\n                                 "), _c('el-date-picker', {
    staticStyle: {
      "width": "44%"
    },
    attrs: {
      "value-format": "yyyy-MM-dd HH:mm",
      "size": "small",
      "type": "date",
      "placeholder": "结束日期"
    },
    model: {
      value: (_vm.AdsForm.end_time),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm, "end_time", $$v)
      },
      expression: "AdsForm.end_time"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "定向维度",
      "name": "four"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "10px",
      "padding": "15px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "媒体版位"
    }
  }, [_vm._l((_vm.MediaFormList), function(m, index) {
    return _c('el-tag', {
      key: index,
      attrs: {
        "size": "mini",
        "closable": "",
        "type": "danger"
      },
      on: {
        "close": function($event) {
          return _vm.closeMedia(index)
        }
      }
    }, [_vm._v(_vm._s('版位' + (index + 1)) + " "), _c('i', {
      staticClass: "el-icon-edit",
      on: {
        "click": function($event) {
          return _vm.EditMediadialogForm(index, m)
        }
      }
    })])
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.addMediadialogForm
    }
  }, [_vm._v("+添加")])], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户性别"
    }
  }, [_c('el-checkbox-group', {
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.SexFormList),
      callback: function($$v) {
        _vm.SexFormList = $$v
      },
      expression: "SexFormList"
    }
  }, [_c('el-checkbox-button', {
    attrs: {
      "label": "NONE"
    }
  }, [_vm._v("不限")]), _vm._v(" "), _c('el-checkbox-button', {
    attrs: {
      "label": "GENDER_MALE"
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('el-checkbox-button', {
    attrs: {
      "label": "GENDER_FEMALE"
    }
  }, [_vm._v("女")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户年龄"
    }
  }, [_vm._l((_vm.AgeFormList), function(a, index) {
    return _c('el-tag', {
      key: index,
      attrs: {
        "size": "mini",
        "closable": "",
        "type": "warning"
      },
      on: {
        "close": function($event) {
          return _vm.closeAge(index)
        }
      }
    }, [_vm._v(_vm._s('年龄段' + (index + 1)) + " "), _c('i', {
      staticClass: "el-icon-edit",
      on: {
        "click": function($event) {
          return _vm.EditAgedialogForm(index, a)
        }
      }
    })])
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.addAgedialogForm
    }
  }, [_vm._v("+添加")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑/创建",
      "width": "50%",
      "append-to-body": _vm.append_body,
      "visible": _vm.MediadialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.MediadialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.MediaForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "投放范围"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    on: {
      "change": _vm.handleInventory
    },
    model: {
      value: (_vm.MediaForm.delivery_range),
      callback: function($$v) {
        _vm.$set(_vm.MediaForm, "delivery_range", $$v)
      },
      expression: "MediaForm.delivery_range"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "DEFAULT"
    }
  }, [_vm._v("默认")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "UNION"
    }
  }, [_vm._v("穿山甲")])], 1)], 1), _vm._v(" "), (_vm.MediaForm.delivery_range == 'DEFAULT') ? _c('el-form-item', {
    attrs: {
      "label": "媒体版位"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    on: {
      "change": _vm.handleInventory
    },
    model: {
      value: (_vm.MediaForm.inventory),
      callback: function($$v) {
        _vm.$set(_vm.MediaForm, "inventory", $$v)
      },
      expression: "MediaForm.inventory"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "smart_inventory"
    }
  }, [_vm._v("优选广告位")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "inventory_type"
    }
  }, [_vm._v("按媒体指定位置")]), _vm._v("、\n\t\t\t\t\t\t\t\t\t\t  "), _c('el-radio-button', {
    attrs: {
      "label": "scene_inventory"
    }
  }, [_vm._v("按场景指定位置")])], 1)], 1) : _vm._e(), _vm._v(" "), ((_vm.MediaForm.inventory == 'scene_inventory') && (_vm.MediaForm.delivery_range == 'DEFAULT')) ? _c('el-form-item', [_c('el-radio-group', {
    model: {
      value: (_vm.MediaForm.scene_inventory),
      callback: function($$v) {
        _vm.$set(_vm.MediaForm, "scene_inventory", $$v)
      },
      expression: "MediaForm.scene_inventory"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "VIDEO_SCENE"
    }
  }, [_vm._v("沉浸式竖版视频场景广告位")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "FEED_SCENE"
    }
  }, [_vm._v("信息流场景广告位")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "TAIL_SCENE"
    }
  }, [_vm._v("视频后贴和尾帧场景广告位")])], 1)], 1) : _vm._e(), _vm._v(" "), ((_vm.MediaForm.inventory == 'inventory_type') && (_vm.MediaForm.delivery_range == 'DEFAULT')) ? _c('el-form-item', [_c('el-checkbox-group', {
    model: {
      value: (_vm.MediaForm.inventory_type),
      callback: function($$v) {
        _vm.$set(_vm.MediaForm, "inventory_type", $$v)
      },
      expression: "MediaForm.inventory_type"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "INVENTORY_FEED"
    }
  }, [_vm._v("头条系")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "INVENTORY_VIDEO_FEED"
    }
  }, [_vm._v("西瓜信息流")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "INVENTORY_HOTSOON_FEED"
    }
  }, [_vm._v("火山信息流")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "INVENTORY_AWEME_FEED"
    }
  }, [_vm._v("抖音信息流")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "label": "INVENTORY_UNION_SLOT"
    }
  }, [_vm._v("穿山甲")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.MediaForm.delivery_range == 'UNION') ? _c('el-form-item', {
    attrs: {
      "label": "投放形式"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.MediaForm.union_video_type),
      callback: function($$v) {
        _vm.$set(_vm.MediaForm, "union_video_type", $$v)
      },
      expression: "MediaForm.union_video_type"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "REWARDED_VIDEO"
    }
  }, [_vm._v("激励视频")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "ORIGINAL_VIDEO"
    }
  }, [_vm._v("原生")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.MediaForm.delivery_range == 'UNION') ? _c('el-form-item', {
    attrs: {
      "label": "设备类型"
    }
  }, [_c('el-checkbox-group', {
    staticStyle: {
      "float": "left"
    },
    model: {
      value: (_vm.MediaForm.device_type),
      callback: function($$v) {
        _vm.$set(_vm.MediaForm, "device_type", $$v)
      },
      expression: "MediaForm.device_type"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "MOBILE"
    }
  }, [_vm._v("智能手机")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "PAD"
    }
  }, [_vm._v("平板")])], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "10px",
      "margin-left": "10px"
    }
  }, [_c('label', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("(*)")]), _vm._v(" 注意:设备类型目前仅投放范围为穿山甲且账户有白名单权限")])], 1) : _vm._e(), _vm._v(" "), (_vm.MediaForm.delivery_range == 'UNION') ? _c('el-form-item', {
    attrs: {
      "label": "试玩素材"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.playableSwitch),
      callback: function($$v) {
        _vm.playableSwitch = $$v
      },
      expression: "playableSwitch"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.playableSwitch && _vm.MediaForm.delivery_range == 'UNION') ? _c('el-form-item', {
    attrs: {
      "label": "试玩素材地址"
    }
  }, [_c('el-autocomplete', {
    staticClass: "inline-input",
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "size": "small",
      "fetch-suggestions": _vm.querySearchAsync,
      "placeholder": "请输入试玩链接地址"
    },
    on: {
      "select": _vm.handleSelectPlay
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "name",
          staticStyle: {
            "color": "#537ec5"
          }
        }, [_vm._v(_vm._s(item.playable_name))]), _vm._v(" "), _c('span', {
          staticClass: "addr"
        }, [_vm._v(_vm._s(item.playable_url))])]
      }
    }], null, false, 83356927),
    model: {
      value: (_vm.MediaForm.playable_url),
      callback: function($$v) {
        _vm.$set(_vm.MediaForm, "playable_url", $$v)
      },
      expression: "MediaForm.playable_url"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.MediadialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": _vm.MediaFormDisabled
    },
    on: {
      "click": _vm.RepeatMediaFormSubmit
    }
  }, [_vm._v("新 建")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.MediaFormSubmit
    }
  }, [_vm._v("保 存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑/创建",
      "append-to-body": _vm.append_body,
      "visible": _vm.AgedialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.AgedialogFormVisible = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', [_c('el-checkbox-group', {
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.AgeForm.age),
      callback: function($$v) {
        _vm.$set(_vm.AgeForm, "age", $$v)
      },
      expression: "AgeForm.age"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "AGE_BELOW_18"
    }
  }, [_vm._v("<18")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "AGE_BETWEEN_18_23"
    }
  }, [_vm._v("18-23")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "AGE_BETWEEN_24_30"
    }
  }, [_vm._v("24-30")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "AGE_BETWEEN_31_40"
    }
  }, [_vm._v("31-40")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "AGE_BETWEEN_41_49"
    }
  }, [_vm._v("41-49")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "AGE_ABOVE_50"
    }
  }, [_vm._v(">=50")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.AgedialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.AgeFormSubmit
    }
  }, [_vm._v("保 存")])], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "创意维度",
      "name": "three"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "10px",
      "padding": "15px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "demo-image__preview"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bold",
      "padding": "10px 0px"
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o",
    staticStyle: {
      "color": "#baabda"
    }
  }), _vm._v(" 上传素材")]), _vm._v(" "), _vm._l((_vm.selectVideoMaterial), function(item) {
    return _c('div', {
      staticClass: "el-image",
      staticStyle: {
        "width": "80px",
        "height": "80px",
        "position": "relative",
        "margin-right": "10px"
      }
    }, [_c('img', {
      staticClass: "el-image__inner",
      attrs: {
        "src": item.image_obj.url
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "el-upload-list__item-actions"
    }, [_c('span', {
      staticClass: "el-upload-list__item-preview",
      on: {
        "click": function($event) {
          return _vm.editVideoMaterial(item)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-edit"
    })]), _vm._v(" "), _c('span', {
      staticClass: "el-upload-list__item-preview",
      on: {
        "click": function($event) {
          return _vm.deleteSelVideoMaterial(item)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-delete"
    })])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "add_avatar",
    on: {
      "click": _vm.openMaterialDialog
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "广告素材上传",
      "visible": _vm.materialDialogVisible,
      "append-to-body": _vm.append_body,
      "width": "50%"
    },
    on: {
      "update:visible": function($event) {
        _vm.materialDialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "materialContain"
  }, [_c('el-form', {
    staticClass: "demo-dynamic"
  }, [_c('el-form-item', {
    attrs: {
      "label": "素材类型"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.image_mode),
      callback: function($$v) {
        _vm.image_mode = $$v
      },
      expression: "image_mode"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "CREATIVE_IMAGE_MODE_VIDEO"
    }
  }, [_vm._v("横版视频")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "CREATIVE_IMAGE_MODE_VIDEO_VERTICAL"
    }
  }, [_vm._v("竖版视频")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "disabled": "",
      "label": "CREATIVE_IMAGE_MODE_SMALL"
    }
  }, [_vm._v("小图")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "disabled": "",
      "label": "CREATIVE_IMAGE_MODE_LARGE"
    }
  }, [_vm._v("大图")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "disabled": "",
      "label": "CREATIVE_IMAGE_MODE_GROUP"
    }
  }, [_vm._v("组图")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "素材内容"
    }
  }, [_c('el-row', [_vm._l((_vm.selectVideo), function(item) {
    return _c('div', {
      staticClass: "add_avatar",
      staticStyle: {
        "margin-right": "10px"
      }
    }, [_c('img', {
      staticClass: "avatar-uploader-icon",
      attrs: {
        "src": item.poster_url
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "el-upload-list__item-actions"
    }, [_c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": "选择封面图",
        "placement": "top"
      }
    }, [_c('span', {
      staticClass: "el-upload-list__item-preview",
      on: {
        "click": function($event) {
          return _vm.video_cover(item)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-picture-outline"
    })])]), _vm._v(" "), _c('span', {
      staticClass: "el-upload-list__item-preview",
      on: {
        "click": function($event) {
          return _vm.deleteSelVideo(item)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-delete"
    })])], 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "add_avatar",
    on: {
      "click": function($event) {
        return _vm.libDialogOpen()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 2), _vm._v(" "), _c('LibPanel', {
    ref: "Lib",
    on: {
      "func": _vm.getSelectVideo
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('span', [_vm._v("封面选取"), _c('label', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("(*必选)")])]), _vm._v(" "), _c('el-row', [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.thumbLoading),
      expression: "thumbLoading"
    }]
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.handleThumb
    },
    model: {
      value: (_vm.selectThumb),
      callback: function($$v) {
        _vm.selectThumb = $$v
      },
      expression: "selectThumb"
    }
  }, _vm._l((_vm.thumb_List), function(i) {
    return _c('div', {
      staticClass: "add_avatar thumb_list",
      staticStyle: {
        "border": "none"
      }
    }, [_c('img', {
      staticClass: "el-image__inner",
      attrs: {
        "src": i.url
      }
    }), _vm._v(" "), _c('el-radio', {
      staticClass: "thumb_select",
      attrs: {
        "label": i
      }
    }, [_vm._v(" ")])], 1)
  }), 0)], 1)])], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.materialDialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.materialConfirm
    }
  }, [_vm._v("确 定")])], 1)])], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bold",
      "padding": "10px 0px"
    }
  }, [_c('i', {
    staticClass: "fa fa-magic",
    staticStyle: {
      "color": "#baabda"
    }
  }), _vm._v(" 创意标题")]), _vm._v(" "), _c('el-form', {
    staticClass: "demo-dynamic"
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "success",
      "plain": ""
    },
    on: {
      "click": _vm.addTitle
    }
  }, [_vm._v("+添加标题")])], 1), _vm._v(" "), _vm._l((_vm.CreateForm.title_list), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": '标题' + (index + 1)
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "60%",
        "margin-right": "10px"
      },
      attrs: {
        "size": "mini"
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          _vm.$set(item, "value", $$v)
        },
        expression: "item.value"
      }
    }), _c('el-button', {
      attrs: {
        "size": "mini",
        "icon": "el-icon-delete",
        "type": "danger"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeDomain(item)
        }
      }
    }, [_vm._v("删除")])], 1)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bold",
      "padding": "10px 0px"
    }
  }, [_c('i', {
    staticClass: "fa fa-tags",
    staticStyle: {
      "color": "#baabda"
    }
  }), _vm._v(" 其他属性")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "副标题"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.CreateForm.advanced_creative_title),
      callback: function($$v) {
        _vm.$set(_vm.CreateForm, "advanced_creative_title", $$v)
      },
      expression: "CreateForm.advanced_creative_title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "创意分类"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "size": "mini",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.CreateForm.third_industry_id),
      callback: function($$v) {
        _vm.$set(_vm.CreateForm, "third_industry_id", $$v)
      },
      expression: "CreateForm.third_industry_id"
    }
  }, _vm._l((_vm.industrylist), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "展现方式"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.CreateForm.creative_display_mode),
      callback: function($$v) {
        _vm.$set(_vm.CreateForm, "creative_display_mode", $$v)
      },
      expression: "CreateForm.creative_display_mode"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "CREATIVE_DISPLAY_MODE_CTR"
    }
  }, [_vm._v("优选")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "CREATIVE_DISPLAY_MODE_RANDOM"
    }
  }, [_vm._v("轮播")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "创意标签"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "最多20个标签，每个不超过10个字，请用#分割"
    },
    model: {
      value: (_vm.CreateForm.ad_keywords),
      callback: function($$v) {
        _vm.$set(_vm.CreateForm, "ad_keywords", $$v)
      },
      expression: "CreateForm.ad_keywords"
    }
  })], 1)], 2)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-footer', [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "warning"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("清除数据")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.submitLoading),
      expression: "submitLoading"
    }],
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.CreateAds
    }
  }, [_vm._v("立即创建")])], 1)], 1)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e18faf4e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/adv/model/model/drawer.vue
// module id = 1111
// module chunks = 36